import cn from 'classnames'
import React from 'react'

import { ComponentType } from '../../lib/types'
import styles from './SectionItem.module.scss'

import { PreferLinkType } from '~types/utils'

export interface BaseSectionItemLinkProps {
  children: React.ReactNode
  selected?: boolean
  hovered?: boolean
  component?: ComponentType
}

type SectionItemLinkProps = BaseSectionItemLinkProps & React.AnchorHTMLAttributes<HTMLAnchorElement>

function SectionItemLink<T extends unknown>(
  {
    component: Component = 'a',
    children,
    className,
    selected,
    hovered,
    ...props
  }: PreferLinkType<BaseSectionItemLinkProps, SectionItemLinkProps, T>,
  ref: React.ForwardedRef<HTMLElement>
) {
  return (
    <Component
      ref={ref}
      className={cn(styles.sectionItemLink, hovered && styles.hovered, selected && styles.selected, className)}
      {...props}
    >
      {children}
    </Component>
  )
}

export default React.forwardRef<HTMLElement, SectionItemLinkProps>(SectionItemLink) as typeof SectionItemLink
